import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { typeCategory, ChevronDownIcon, Tooltip, MarkdownContent, MergeIcon } from "@graphiql/react";
import { ArgInput } from "./arg-input/index.js";
import { rendersAsInputObject } from "./arg-input/arg-input-by-type.js";
const FieldRow = (t0) => {
  const $ = c(50);
  const {
    field,
    path,
    selected,
    hasChildren,
    expanded,
    flash: t1,
    current: t2,
    argValues: t3,
    argVariables: t4,
    onExtractFragment,
    onToggle,
    onExpand,
    onSetArg,
    onPromoteArg,
    onDemoteArg
  } = t0;
  const flash = t1 === void 0 ? false : t1;
  const current = t2 === void 0 ? false : t2;
  let t5;
  if ($[0] !== t3) {
    t5 = t3 === void 0 ? {} : t3;
    $[0] = t3;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const argValues = t5;
  let t6;
  if ($[2] !== t4) {
    t6 = t4 === void 0 ? {} : t4;
    $[2] = t4;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const argVariables = t6;
  let t7;
  if ($[4] !== field.name) {
    t7 = {
      kind: "field",
      name: field.name
    };
    $[4] = field.name;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== path || $[7] !== t7) {
    t8 = [...path, t7];
    $[6] = path;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const fullPath = t8;
  const indent = path.length * 12;
  const hasArgs = field.args.length > 0;
  const deprecated = Boolean(field.deprecationReason);
  const nameClassName = `graphiql-qb-field-name${deprecated ? " graphiql-qb-field-name--deprecated" : ""}`;
  const typeColorCategory = typeCategory(field.type);
  const t9 = `graphiql-qb-field-row${flash ? " graphiql-qb-flash" : ""}${current ? " graphiql-qb-current" : ""}`;
  let t10;
  if ($[9] !== indent) {
    t10 = {
      paddingLeft: indent
    };
    $[9] = indent;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = selected ? "true" : "false";
  let t12;
  if ($[11] !== expanded || $[12] !== field.name || $[13] !== fullPath || $[14] !== hasChildren || $[15] !== nameClassName || $[16] !== onExpand || $[17] !== onToggle || $[18] !== selected) {
    t12 = hasChildren ? /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-qb-field-toggle", onClick: () => onExpand(fullPath), "aria-expanded": expanded, "aria-label": `${expanded ? "Collapse" : "Expand"} ${field.name}`, children: [
      /* @__PURE__ */ jsx("span", { className: expanded ? "graphiql-qb-chevron-expanded" : "graphiql-qb-chevron-collapsed", children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }),
      /* @__PURE__ */ jsx("span", { className: nameClassName, children: field.name })
    ] }) : /* @__PURE__ */ jsxs("label", { className: "graphiql-qb-field-toggle", children: [
      /* @__PURE__ */ jsx("input", { type: "checkbox", checked: selected, onChange: () => onToggle(fullPath), "aria-label": `Toggle ${field.name}`, className: "graphiql-qb-field-checkbox" }),
      /* @__PURE__ */ jsx("span", { className: nameClassName, children: field.name })
    ] });
    $[11] = expanded;
    $[12] = field.name;
    $[13] = fullPath;
    $[14] = hasChildren;
    $[15] = nameClassName;
    $[16] = onExpand;
    $[17] = onToggle;
    $[18] = selected;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== deprecated || $[21] !== field.deprecationReason) {
    t13 = deprecated && /* @__PURE__ */ jsx(Tooltip, { label: /* @__PURE__ */ jsx(MarkdownContent, { type: "deprecation", className: "graphiql-qb-deprecation-tooltip", children: field.deprecationReason ?? "" }), children: /* @__PURE__ */ jsx("span", { className: "graphiql-qb-field-deprecated", "aria-label": "deprecated", children: "DEP" }) });
    $[20] = deprecated;
    $[21] = field.deprecationReason;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== field.name || $[24] !== onExtractFragment) {
    t14 = onExtractFragment && /* @__PURE__ */ jsx("span", { className: "graphiql-qb-field-actions", children: /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-qb-extract-fragment-btn", onClick: onExtractFragment, "aria-label": `Extract ${field.name} to a fragment`, children: [
      /* @__PURE__ */ jsx(MergeIcon, {}),
      /* @__PURE__ */ jsx("span", { children: "Extract to fragment" })
    ] }) });
    $[23] = field.name;
    $[24] = onExtractFragment;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = `graphiql-qb-field-type graphiql-qb-field-type--${typeColorCategory}`;
  const t16 = String(field.type);
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = /* @__PURE__ */ jsx("span", { className: t15, children: t16 });
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t17) {
    t18 = /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-field-header", children: [
      t12,
      t13,
      t14,
      t17
    ] });
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== argValues || $[35] !== argVariables || $[36] !== field.args || $[37] !== fullPath || $[38] !== hasArgs || $[39] !== onDemoteArg || $[40] !== onPromoteArg || $[41] !== onSetArg || $[42] !== selected) {
    t19 = selected && hasArgs && /* @__PURE__ */ jsx("div", { className: "graphiql-qb-field-args", children: field.args.map((arg) => {
      const varName = argVariables[arg.name];
      const isVariable = varName !== void 0;
      const isObjectArg = rendersAsInputObject(arg.type);
      return /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-arg-row", children: [
        !isObjectArg && /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-arg-name", children: [
          arg.name,
          ":"
        ] }),
        /* @__PURE__ */ jsx(ArgInput, { arg, value: argValues[arg.name] ?? "", onChange: (v) => onSetArg == null ? void 0 : onSetArg(fullPath, arg.name, v), isVariable, variableName: varName, onPromote: onPromoteArg ? (argName, suggested) => onPromoteArg(fullPath, argName, suggested) : void 0, onDemote: onDemoteArg ? (argName_0, vName) => onDemoteArg(fullPath, argName_0, vName) : void 0 })
      ] }, arg.name);
    }) });
    $[34] = argValues;
    $[35] = argVariables;
    $[36] = field.args;
    $[37] = fullPath;
    $[38] = hasArgs;
    $[39] = onDemoteArg;
    $[40] = onPromoteArg;
    $[41] = onSetArg;
    $[42] = selected;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t10 || $[45] !== t11 || $[46] !== t18 || $[47] !== t19 || $[48] !== t9) {
    t20 = /* @__PURE__ */ jsxs("div", { className: t9, style: t10, "data-testid": "field-row", "data-selected": t11, children: [
      t18,
      t19
    ] });
    $[44] = t10;
    $[45] = t11;
    $[46] = t18;
    $[47] = t19;
    $[48] = t9;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
};
export {
  FieldRow
};
//# sourceMappingURL=field-row.js.map
